import React from 'react';

export const EmptyState = ({ title, description }) => (
    <div className='empty-state'>
        <div className='empty-state__icon'>📭</div>
        <h3 className='empty-state__title'>{title}</h3>
        <p className='empty-state__description'>{description}</p>
    </div>
);
